import React, { useEffect } from "react"
import bubbleArt from "../../assets/images/bubble_art.svg"
import taglineBubble from "../../assets/images/section1_bubble.svg"
import {
  SIGNUP_TEXT,
  PARTNER_SIGN_UP_MODAL_TITLE,
  CONTINUE_AS_LOGGED_IN_USER,
  PARTNER_SIGN_UP_MODAL_CONTENT,
  SUB_TAGLINE,
  LOGOUT_BUTTON,
} from "../../constants/messages"
import { connect } from "react-redux"
import { secretCodeVerification } from "../../redux/actionCreators/invitePeople"
import RegisterPartnerByEmail from "../../components/RegisterNewUserByEmail/RegisterPartnerByEmail"
import RegisterPartnerByMobile from "../../components/RegisterNewUserByMobile/RegisterPartnerByMobile"
import "./PartnerSignUpWithInvite.scss"
import { logout } from "../../redux/actionCreators/auth"
import { TextTag as Text, CustomModal, Button } from "../../atoms"
import _ from "../../utils/lodashUtils"
import { FirebaseContext, FIREBASE_STATE_KEYS } from "../../firebase"
import { SCREENS } from "../../constants/screens"
import EmailSignIn from "../../components/EmailSignIn/EmailSignIn"
import MobileSignIn from "../../components/MobileSignIn/MobileSignIn"
import coupleArt from "../../assets/images/couple_art.gif"
import HomePageInfo from "../../components/HomePage/HomePageInfo"
import { formatPhoneNumber } from "../../utils/helpers"

const PartnerSignUpWithInvite = props => {
  const { dateState, partnerState } = React.useContext(FirebaseContext)
  const chatSpaceName = _.get(dateState, "chatSpaceName", "")
  const partnerActiveScreen = _.get(
    partnerState,
    FIREBASE_STATE_KEYS.ACTIVE_SCREEN
  )
  useEffect(() => {
    //call verify-code
    props.secretCodeVerification({
      secretCode: props.match.params.inviteCode,
      chatSpaceName,
      notify: partnerActiveScreen !== SCREENS.COUPLING,
    })
  }, [])

  const getPhoneNumber = phoneNumber => {
    const formattedPhoneNumber = formatPhoneNumber(phoneNumber)

    return formattedPhoneNumber && formattedPhoneNumber.intlCode
      ? `${formattedPhoneNumber.intlCode} ${formattedPhoneNumber.telephoneNumber}`
      : phoneNumber
  }

  const goToDashboard = () => {
    // If user already is signed in, show pop up, else directly signin
    let userName = _.get(props.user, "username")

    if (_.get(props.user, "signup_method") === "PHONE") {
      userName = getPhoneNumber(userName)
    }

    let partnerUserName = _.get(props.partnerInviteData, "partner_identifier")

    if (
      partnerUserName &&
      _.get(props.partnerInviteData, "signup_method") === "Phone"
    ) {
      partnerUserName = getPhoneNumber(partnerUserName)
    } else if (!partnerUserName) {
      partnerUserName = _.get(props.partnerDetails, "partner2_identifier")

      if (_.get(props.partnerDetails, "invite_type") === "Phone") {
        partnerUserName = getPhoneNumber(partnerUserName)
      }
    }

    return (
      userName &&
      partnerUserName &&
      userName !== partnerUserName && (
        <CustomModal
          title={PARTNER_SIGN_UP_MODAL_TITLE(userName)}
          visible={true}
          footer={[
            <Button
              type="primary"
              key="save"
              onClick={async () => {
                await props.logout()
                //call verify-code
                props.secretCodeVerification({
                  secretCode: props.match.params.inviteCode,
                  chatSpaceName,
                })
              }}
            >
              {LOGOUT_BUTTON}
            </Button>,
            <Button
              key="cancel"
              onClick={() => props.history.push("/dashboard")}
            >
              {CONTINUE_AS_LOGGED_IN_USER}
            </Button>,
          ]}
        >
          {PARTNER_SIGN_UP_MODAL_CONTENT(userName, partnerUserName)}
        </CustomModal>
      )
    )
  }

  return (
    <div id="PartnerSignUpWithInvite">
      <div className="home-background">
        <div className="sideLeft">
          <div className="reverse-content">
            <div className="couple-art-box">
              <img className="couple-art" src={coupleArt} alt="coupleSeat" />
            </div>
            <div className="jomo-text">
              <div className="tagline">
                <img
                  className="bubble-set"
                  src={taglineBubble}
                  alt="Closer together"
                />
                <Text textType="taglineBold">{SIGNUP_TEXT}</Text>
              </div>
              <div className="sub-tagline">
                <Text textType="bodyHeading">{SUB_TAGLINE} </Text>
              </div>
            </div>
          </div>
        </div>
        <div className="sideRight">
          <div className="signupBg">
            <div>
              {_.get(props, "isAuthenticated") ? (
                goToDashboard()
              ) : (
                <div>
                  {!_.get(props.partnerInviteData, "account_exist") &&
                  _.get(props.partnerInviteData, "signup_method") ===
                    "Email" ? (
                    <RegisterPartnerByEmail
                      email={_.get(props.partnerInviteData, "username")}
                    />
                  ) : !_.get(props.partnerInviteData, "account_exist") &&
                    _.get(props.partnerInviteData, "signup_method") ===
                      "Phone" ? (
                    <RegisterPartnerByMobile
                      phoneNumber={_.get(props.partnerInviteData, "username")}
                    />
                  ) : _.get(props.partnerInviteData, "account_exist") &&
                    _.get(props.partnerInviteData, "signup_method") ===
                      "Email" ? (
                    <EmailSignIn
                      email={_.get(props.partnerInviteData, "username")}
                      isPartnerSignup={
                        _.get(props, "match.params.inviteCode") ? true : false
                      }
                    />
                  ) : (
                    <MobileSignIn
                      phoneNumber={_.get(props.partnerInviteData, "username")}
                      isPartnerSignup={
                        _.get(props, "match.params.inviteCode") ? true : false
                      }
                    />
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="bubble-set-box">
            <img className="bubble-set" src={bubbleArt} alt="bubbles" />
          </div>
        </div>
      </div>
      <HomePageInfo />
    </div>
  )
}
const mapStateToProps = state => ({
  partnerInviteData: state.auth.partnerInviteData,
  isAuthenticated: state.auth.isAuthenticated,
  user: state.auth.user,
  partnerDetails: _.get(state.invitePeople, "partnerDetails"),
})
export default connect(mapStateToProps, { secretCodeVerification, logout })(
  PartnerSignUpWithInvite
)
